/**
 * Datas de notification. A entrada é SEMPRE epoch em **segundos** — é o que o
 * `TimestampInt` do back serializa.
 */

const RELATIVE = new Intl.RelativeTimeFormat('pt-BR', { numeric: 'auto' })

const MINUTE = 60
const HOUR = 60 * MINUTE
const DAY = 24 * HOUR
const WEEK = 7 * DAY
/** Mês/ano médios: só rótulo humano, não aritmética de calendário. */
const MONTH = 30 * DAY
const YEAR = 365 * DAY

/** "agora mesmo", "há 5 minutos", "ontem", "em 2 horas". */
export function formatRelativeFromEpoch(seconds: number): string {
  const deltaSeconds = seconds - Math.floor(Date.now() / 1000)
  const abs = Math.abs(deltaSeconds)

  if (abs < MINUTE) return 'agora mesmo'
  if (abs < HOUR) return RELATIVE.format(Math.round(deltaSeconds / MINUTE), 'minute')
  if (abs < DAY) return RELATIVE.format(Math.round(deltaSeconds / HOUR), 'hour')
  if (abs < WEEK) return RELATIVE.format(Math.round(deltaSeconds / DAY), 'day')
  if (abs < MONTH) return RELATIVE.format(Math.round(deltaSeconds / WEEK), 'week')
  if (abs < YEAR) return RELATIVE.format(Math.round(deltaSeconds / MONTH), 'month')
  return RELATIVE.format(Math.round(deltaSeconds / YEAR), 'year')
}

/** "27/07/2026 12:00" — usado onde a data exata importa (detalhe, tooltip). */
export function formatAbsoluteFromEpoch(seconds: number): string {
  return new Date(seconds * 1000).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}
